__webpack_require__.p = "/Scripts/dist/";